let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hCyxS")).then(() => parcelRequire('h9J5A'));